import React from 'react';
import './home.css'
import Usermangement from '../sections/user-mangement';

const USERR = () => {
    return ( 
        <>
        <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Usermangement />
        </section>
        </>
     );
}
 
export default USERR ;